<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
      <v-spacer></v-spacer>
      <accumulate-nav-button></accumulate-nav-button>
    </v-app-bar>
    <v-card width="600" class="my-v-card">
      <v-card-title>パスワードをリセット</v-card-title>
      <v-card-subtitle>ご登録のEmailアドレス宛に、パスワードをリセットするためのリンクをお送りします。</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field v-model="email" placeholder="Email..." type="email" outlined hide-details single-line>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="primary" :disabled="isProcessing || !email" @click="sendEmail">
              <v-progress-circular
                v-if="isProcessing"
                indeterminate
                color="primary"
                :width="2"
                :size="20"
              ></v-progress-circular>
              {{ isProcessing ? null : '送信する' }}
            </v-btn>
          </v-col>
        </v-row>
        <sign-up-message></sign-up-message>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import AccumulateNavButton from '@/components/buttons/AccumulateNavButton.vue'
import { firebaseAuth } from '@/services/firebase'
import { alertError } from '@/helpers/error'
import SignUpMessage from '@/components/messages/SignUpMessage.vue'

const userStore = createNamespacedHelpers('user')

export default {
  components: { SeaPlusNavIcon, AccumulateNavButton, SignUpMessage },
  data: () => ({
    isProcessing: false,
    email: ''
  }),
  computed: {
    plan() {
      return this.$route.query.plan
    }
  },
  methods: {
    ...userStore.mapActions(['updateUser']),
    sendEmail() {
      this.isProcessing = true
      firebaseAuth
        .sendPasswordResetEmail(this.email)
        .then(() => this.$router.push('/reset-password-2'))
        .catch((error) => {
          console.log({ error })
          this.isProcessing = false
          alertError(error)
        })
        .finally(() => (this.isProcessing = false))
    }
  }
}
</script>
